import { useIntegrationInstancesAndDefinitions } from '@jupiterone/jupiter-web-toolkit';
import { CircularProgress } from '@material-ui/core';
import React from 'react';
import getIntegrationInstanceDisplayName from './getIntegrationInstanceDisplayName';

interface Props {
  instanceIds: string[];
}

const IntegrationInstanceItemsDisplay = ({ instanceIds }: Props) => {
  const {
    loading,
    instances,
    definitions,
  } = useIntegrationInstancesAndDefinitions();
  return loading ? (
    <CircularProgress size={10} />
  ) : (
    <div>
      {instanceIds
        .map((instanceId) => {
          const instance = instances?.find((i) => i.id === instanceId);
          return !instance || !instances || !definitions
            ? `ID: ${instanceId}`
            : getIntegrationInstanceDisplayName(instance, definitions);
        })
        .join(',')}
    </div>
  );
};

export default IntegrationInstanceItemsDisplay;
